export const dateFormatOptions = [
  {
    value: 'DD/MM/YYYY',
    altValue: 'd/m/Y', // Unfortunately, carbon does not use the same formatting model as moment
    pattern: '\\d{1,2}\\/\\d{1,2}\\/\\d{4}'
  },
  {
    value: 'MM/DD/YYYY',
    altValue: 'm/d/Y',
    pattern: '\\d{1,2}\\/\\d{1,2}\\/\\d{4}'
  },
  {
    value: 'DD/MM/YY',
    altValue: 'd/m/y',
    pattern: '\\d{1,2}\\/\\d{1,2}\\/\\d{2}'
  },
  {
    value: 'MM/DD/YY',
    altValue: 'm/d/y',
    pattern: '\\d{1,2}\\/\\d{1,2}\\/\\d{2}'
  },
  {
    value: 'DD MMM YYYY',
    altValue: 'd M Y',
    pattern: '\\d{1,2}\\s[a-zA-z]{3}\\s\\d{4}'
  },
  {
    value: 'DD MMMM YYYY',
    altValue: 'd F Y',
    pattern: '\\d{1,2}\\s[a-zA-z]+\\s\\d{4}'
  },
  {
    value: 'MMM DD YYYY',
    altValue: 'M d Y',
    pattern: '[a-zA-z]{3}\\s\\d{1,2}\\s\\d{4}'
  },
  {
    value: 'MMMM DD YYYY',
    altValue: 'F d Y',
    pattern: '[a-zA-z]+\\s\\d{1,2}\\s\\d{4}'
  }
]

export const timeFormatOptions = [
  {
    value: 'HH:mm',
    altValue: 'H:i'
  },
  {
    value: 'HH:mm:ss',
    altValue: 'H:i:S'
  }
  /*  {
    value: 'hh:mm A',
    altValue: 'h:i K'
  } */
]

export const [DEFAULT_DATE_FORMAT] = dateFormatOptions

export const [DEFAULT_TIME_FORMAT] = timeFormatOptions

// Formats in models only use the value like 'DD/MM/YYYY'
// To work properly, we need to get the whole object corresponding to that value
const getFormatConfigByValueFor = (options) => (value) => {
  if (!value) return

  const formatConfig = options.find((option) => option.value === value)
  if (!formatConfig) {
    console.warn(
      `[Date/time format from model] Could not match "${value}" with any platform-defined formats.`
    )
  }
  return formatConfig
}

export const getDateFormatConfigByValue =
  getFormatConfigByValueFor(dateFormatOptions)
export const getTimeFormatConfigByValue =
  getFormatConfigByValueFor(timeFormatOptions)
